import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import Copy from '../../atoms/copy/copy';
import Headline from '../../atoms/headline/headline';
import Image from '../../atoms/image/image';

import BasicTeaserBackgroundLandscape from './backgroundShapes/basicTeaserBackgroundLandscape';
import BasicTeaserBackgroundPortrait from './backgroundShapes/basicTeaserBackgroundPortrait';
import { LongArrowRight } from '../../icons/arrow/arrow';

import StyledBasicTeaser from './basicTeaser.style';

import MixedCopy from '../mixed-copy/mixedCopy';

const imageSizes = [
  {
    condition: 'min-width: 980px',
    width: '30vw'
  },
  {
    condition: 'min-width: 450px',
    width: '45vw'
  },
  {
    width: '100vw'
  }
];

const BasicTeaser = props => {
  const {
    copy,
    introCopy,
    headline,
    image,
    orientation = 'landscape',
    size = 'm',
    subline,
    uri
  } = props;
  return (
    <StyledBasicTeaser {...props} orientation={orientation} size={size}>
      <Link
        href={{ pathname: `/universal`, query: { uri } }}
        as={uri}
        className="basicTeaser__link"
      >
        <div className="basicTeaser__background">
          {image ? (
            <div className="basicTeaser__image-wrapper">
              <Image {...image} sizes={imageSizes} />
            </div>
          ) : (
            <div className="basicTeaser__background-wrapper" aria-hidden="true">
              {orientation === 'landscape' || size === 'm' ? (
                <BasicTeaserBackgroundLandscape />
              ) : (
                <BasicTeaserBackgroundPortrait />
              )}
            </div>
          )}
        </div>
        <div className="basicTeaser__mask" />
        <div className="basicTeaser__content">
          <div className="basicTeaser__headlines">
            {subline && <Headline tag="h3">{subline}</Headline>}
            {size === 'm' ? (
              <Headline tag="h3" primary>
                {headline}
              </Headline>
            ) : (
              <Headline tag="h2" teaser>
                {headline}
              </Headline>
            )}
          </div>

          {copy && (
            <div className="basicTeaser__copy">
              <Copy>{copy}</Copy>
            </div>
          )}
          {introCopy && (
            <MixedCopy
              fullWidth
              html={introCopy.length > 200 ? `${introCopy.substring(0, 200)}...` : introCopy}
            />
          )}

          <div className="basicTeaser__arrow">
            <LongArrowRight role="presentation" />
          </div>
        </div>
      </Link>
    </StyledBasicTeaser>
  );
};

BasicTeaser.propTypes = {
  copy: PropTypes.string,
  introCopy: PropTypes.string,
  headline: PropTypes.string.isRequired,
  image: PropTypes.shape(),
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  size: PropTypes.oneOf(['s', 'm']),
  subline: PropTypes.string,
  uri: PropTypes.string
};

export default BasicTeaser;
